module.exports = __webpack_public_path__ + "static/img/84035B_1_R_20201022_fit.04573d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/84035B_1_R_20201022_fit.png
// module id = Cbp4
// module chunks = 0